(function($) {
    $(document).ready(function($) {
        var snScrollMagic = function(e, settings, animationController) {
            this.element = e;
            this.settings = settings;
            this.bindMagic = function() {
                try {
                    var $element = $(this.element);
                    if (settings.type === 'toggleClass' || settings.type ===
                        'removeClass') {
                        var classToSet = settings.classToSet;
                        if (!classToSet) {
                            console.error(
                                'Animation error: No css class configured on this element:',
                                this.element);
                            return true; //continue
                        }
                        var offset = 50;
                        if (typeof settings.offset !==
                            'undefined') offset = settings.offset;

                        var triggerHook = settings.triggerHook || 'onCenter';
                        var triggerElement = settings.triggerElement || null;
                        var initObj = {
                            triggerHook: triggerHook,
                            triggerElement: triggerElement,
                        };

                        if (settings.removeClassOnScrollingUp) {
                            new ScrollMagic.Scene(initObj).addTo(
                                animationController).
                                setClassToggle(this.element, classToSet).
                                on('update', function() {
                                    var scrollPos = animationController.info(
                                        'scrollPos');
                                    if (animationController.info(
                                            'scrollDirection') === 'FORWARD' &&
                                        scrollPos > (offset +
                                            getTriggerOffsetTop(
                                                triggerElement))) {
                                        $element.addClass(classToSet);
                                    } else {
                                        $element.removeClass(classToSet);
                                    }
                                });
                        } else {
                            initObj.offset = offset;
                            new ScrollMagic.Scene(initObj).setClassToggle(
                                this.element, classToSet).
                                addTo(animationController).
                                on('update', function() {
                                    if (settings.type === 'removeClass') {
                                        var scrollPos = animationController.info(
                                            'scrollPos');
                                        if (scrollPos > (offset +
                                            getTriggerOffsetTop(
                                                triggerElement))) {
                                            $element.removeClass(classToSet);
                                        } else {
                                            $element.addClass(classToSet);
                                        }
                                    }
                                });
                        }
                    } else if (settings.type === 'removeTranslateY') {

                        var tween = new TimelineMax().add(
                            TweenMax.to(this.element, 1, {y: 0}),
                        );

                        var scene = new ScrollMagic.Scene().setTween(tween).
                            addTo(animationController);

                        var duration = '80%';
                        if (settings.durationElement) {
                            var $e = $(settings.durationElement);
                            if ($e.length) {
                                duration = $e.height();
                                $(window).resize(function() {
                                    scene.duration($e.height());
                                });
                            }
                        }
                        scene.duration(duration);
                    } else if (settings.type === 'removeTranslateX') {

                        var tween = new TimelineMax().add(
                            TweenMax.to(this.element, 1, {x: 0}),
                        );

                        var scene = new ScrollMagic.Scene().setTween(tween).
                            addTo(animationController);

                        var duration = '80%';
                        scene.duration(duration);
                    }
                } catch (e) {
                    console.error(e);
                }
            };
        };

        // Sick animations controller
        var mainController = new ScrollMagic.Controller();

        $(window).resize(function() {
            mainController.update();
        });

        $('[data-scrollmagic]').each(function() {
            var $this = $(this);
            var settings = $this.data('scrollmagic');
            var element = this;
            if ($.isArray(settings)) {
                $.each(settings, function(i, setting) {
                    var magic = new snScrollMagic(element, setting,
                        mainController);
                    magic.bindMagic();
                });
            } else {
                var magic = new snScrollMagic(element, settings,
                    mainController);
                magic.bindMagic();
            }
        });

        /** Parallax for Images
         <div id="parallax-section" class="parallax">
         <div>
         {include file="../../components/img.tpl"}
         </div>
         </div>

         .parallax {
         max-height: 300px;
         overflow: hidden;

         > div {
         will-change: transition;
         }
         }
         */
        // if ($('#parallax-section').length) {
        // 	var parallaxController = new ScrollMagic.Controller({
        // 		globalSceneOptions: { triggerHook: 'onEnter', duration: '200%', offset: 300 },
        // 	});
        //
        // 	new ScrollMagic.Scene({ triggerElement: '#parallax-section' })
        // 		.setTween('#parallax-section > div', { y: '-100%', ease: Linear.easeNone })
        // 		.addTo(parallaxController);
        // }
    });
})(jQuery);

function getTriggerOffsetTop(triggerElement) {
    var triggerOffsetTop = 0;
    if (triggerElement) {
        var triggerOffset = $(triggerElement).offset();
        if (triggerOffset) triggerOffsetTop = triggerOffset.top;
    }
    return triggerOffsetTop;
}

